import { render, staticRenderFns } from "./ZoomSDKComponent.vue?vue&type=template&id=1a5f57cb&scoped=true&"
import script from "./ZoomSDKComponent.vue?vue&type=script&lang=js&"
export * from "./ZoomSDKComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f57cb",
  null
  
)

export default component.exports